// extracted by mini-css-extract-plugin
module.exports = {"heading":"Questions_heading__QgJSW","wrapper":"Questions_wrapper__ylNam","grid":"Questions_grid__71Y3o","item":"Questions_item__waIgh"};